import React from "react";

const ACCENT = {
  blue:   { border: "border-blue-500",   bg: "bg-blue-50",   icon: "text-blue-500",   bar: "bg-blue-500"   },
  emerald:{ border: "border-emerald-500",bg: "bg-emerald-50",icon: "text-emerald-500",bar: "bg-emerald-500" },
  violet: { border: "border-violet-500", bg: "bg-violet-50", icon: "text-violet-500", bar: "bg-violet-500"  },
  amber:  { border: "border-amber-500",  bg: "bg-amber-50",  icon: "text-amber-500",  bar: "bg-amber-500"   },
};

export default function StatCard({ label, value, icon: Icon, color = "blue", sub }) {
  const c = ACCENT[color] || ACCENT.blue;

  return (
    <div className={`bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow`}>
      <div className={`h-1 ${c.bar}`} />
      <div className="p-5 flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <p className="text-[11px] font-bold text-slate-400 uppercase tracking-widest mb-2">{label}</p>
          <p className="text-2xl font-bold text-navy-900 font-serif truncate">{value}</p>
          {sub && <p className="text-xs text-slate-400 mt-1">{sub}</p>}
        </div>
        {Icon && (
          <div className={`w-11 h-11 rounded-xl ${c.bg} flex items-center justify-center flex-shrink-0`}>
            <Icon size={22} className={c.icon} />
          </div>
        )}
      </div>
    </div>
  );
}
